<template>
    <div class="stuff-list-container">
        <div v-if="!list.length" class="empty-tip">
            暂无物品～
        </div>
        <ul v-else class="stuff-list">
          <slot></slot>
        </ul>
    </div>
</template>

<script>
export default {
    name: "StuffList",
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

<style scoped>
.stuff-list-container {
    padding: 16px 20px 24px;
    overflow: hidden;
}

.empty-tip {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    margin-top: -20px;
    font-size: 48px;
    font-weight: bold;
    color: #fff;
    text-align: center;
}
.stuff-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  max-height: 560px;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: auto;
}
.stuff-list::-webkit-scrollbar {
    display: none;
}
</style>